import { Drawer as MuiDrawer } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const LABELS_DRAWER_WIDTH = 576

export const Drawer = styled(MuiDrawer)`
  .MuiPaper-root {
    height: 100%;
    overflow-y: hidden;
    background: ${theme.colors.legacySurfaceContainerBackground};
    width: ${LABELS_DRAWER_WIDTH}px;
    padding: ${theme.spacing.xLarge}px ${theme.spacing.xLarge}px ${theme.spacing.large}px;

    ::-webkit-scrollbar {
      display: none;
    }

    /* Scoped here: the field and radio components are shared with the settings drawer. */
    html[data-theme='light'] & {
      background: ${theme.colors.surfaceContainerBackground};

      .labels-drawer-header-subtitle,
      .form-control-label,
      .MuiFormLabel-root,
      #uncontrolled-select-label,
      .label-filters-wrapper .label {
        color: ${theme.colors.textSecondary};
      }

      .MuiOutlinedInput-input,
      .date-picker-wrapper input {
        color: ${theme.colors.foreground};
        -webkit-text-fill-color: ${theme.colors.foreground};
      }

      .char-counter-text:not(.text-danger) {
        color: ${theme.colors.textCaption};
      }

      .MuiFormControlLabel-label.Mui-disabled {
        color: ${theme.colors.textCaption};
      }

      .create-label-button {
        color: #fdfdfd;
      }
    }

    div[role='presentation'] {
      height: 100%;
      overflow-y: hidden;

      .wrapper-inner {
        position: relative;
        height: 100%;
        overflow-y: hidden;
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: ${theme.spacing.large}px;

        .loading-wrapper {
          position: absolute;
          height: 100vh;
          width: 100%;
          z-index: 10;
          display: flex;
          align-items: center;
          justify-content: center;

          > div {
            margin-top: 15px;
            position: absolute;
            left: auto;
            top: 50%;
          }
        }

        .labels-drawer-header-block {
          display: flex;
          align-items: center;
          width: 100%;

          .header {
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
            width: 100%;

            .header-title-wrapper {
              display: flex;
              flex-direction: column;
              gap: 8px;
            }

            .close-icon {
              width: 40px;
              height: 40px;

              &:hover {
                background: rgba(202, 196, 208, 0.12);
              }

              svg {
                path {
                  fill: ${theme.colors.foreground};
                }
              }
            }

            .labels-drawer-header-title {
              color: ${theme.colors.menuItemText};
              font-family: ${theme.typography.fontFamily.primary};
              font-size: ${theme.typography.fontSize.xxxxLarge};
              font-style: normal;
              font-weight: ${theme.typography.fontWeight.bold};
              line-height: 42px;
            }

            .labels-drawer-header-subtitle {
              color: ${theme.colors.foreground};
              font-family: Quicksand, sans-serif;
              font-size: 14px;
              font-style: normal;
              font-weight: 400;
              line-height: 22px;
            }
          }

          .custom-header {
            justify-content: flex-start;
          }
        }

        .labels-drawer-content {
          height: 100%;
          overflow-y: hidden;
        }

        .drawer-actions {
          background: ${theme.colors.primaryDarker};
          border-top: 1px solid rgba(222, 189, 217, 0.5);
          padding: ${theme.spacing.small}px ${theme.spacing.medium}px;
          display: flex;
          align-items: center;
          gap: ${theme.spacing.small}px;
          position: fixed;
          bottom: 0;
          width: 320px;
          right: 0;

          .icon-block {
            border: 1px solid ${theme.colors.controlBorder};
            border-radius: 100%;
            padding: ${theme.spacing.xSmall}px;
            width: 40px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .MuiButton-root {
            border-radius: 44px;
            border: 1px solid ${theme.colors.controlBorder};
            background: ${theme.colors.backgroundLight};
            box-shadow: ${theme.attributes.boxShadow.overallScoreWrapper};
            color: ${theme.colors.white};
            width: 100%;
          }
        }

        .edit-actions {
          button {
            padding-right: ${theme.spacing.xSmall}px;
          }

          .save-btn {
            border: 1px solid rgba(227, 227, 227, 0.12) !important;
            background: ${theme.colors.textPrimary};
            color: ${theme.baseColors.primary[20]};

            &:hover {
              svg {
                path {
                  fill: ${theme.baseColors.primary[20]};
                }
              }
            }
          }
        }

        .disabled-button {
          background: rgba(227, 227, 227, 0.12) !important;
          color: ${theme.colors.neutral} !important;

          svg {
            path {
              fill: ${theme.colors.neutral} !important;

              &:last-child {
                stroke: ${theme.colors.neutral} !important;
              }
            }
          }
        }
      }
    }
  }
`
